import { useEffect, useId, useState } from "react";
import { Icon as Iconify, buildIcon, loadIcon } from "@iconify/react";

const defaultGradientStops = [
  { offset: "0.3397", color: "#EDCB88" },
  { offset: "0.9414", color: "#966C2D" },
];

export default function Icon(props) {
  const {
    tag,
    icon,
    onClick,
    className,
    style,
    width,
    height,
    gradient = false,
    gradientStops = defaultGradientStops,
  } = props;

  const Tag = tag || "article";
  const instanceId = useId().replace(/:/g, "");
  const [svgMarkup, setSvgMarkup] = useState("");

  useEffect(() => {
    if (!gradient || !icon) {
      setSvgMarkup("");
      return;
    }

    let active = true;

    loadIcon(icon).then((iconData) => {
      if (!active || !iconData) return;

      const svg = buildIcon(iconData, {
        height: String(height || 18),
        width: String(width || 18),
      });
      const gradientId = `icon-gradient-${icon.replace(
        /[^a-z0-9]/gi,
        "-",
      )}-${instanceId}`;
      const body = svg.body.replaceAll("currentColor", `url(#${gradientId})`);
      const iconWidth = iconData.width || 24;
      const iconHeight = iconData.height || 24;

      setSvgMarkup(`
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 ${iconWidth} ${iconHeight}"
          width="${width || 18}"
          height="${height || 18}"
          fill="none"
        >
          <defs>
            <linearGradient id="${gradientId}" x1="${iconWidth / 2}" y1="0" x2="${iconWidth / 2}" y2="${iconHeight}" gradientUnits="userSpaceOnUse">
              ${gradientStops
                .map(
                  ({ offset, color }) =>
                    `<stop offset="${offset}" stop-color="${color}" />`,
                )
                .join("")}
            </linearGradient>
          </defs>
          ${body}
        </svg>
      `);
    });

    return () => {
      active = false;
    };
  }, [gradient, icon, height, width, gradientStops, instanceId]);

  if (gradient) {
    return (
      <Tag
        style={style}
        className={`icon${className ? ` ${className}` : ""}`}
        onClick={onClick ? onClick : undefined}
        aria-hidden="true"
        dangerouslySetInnerHTML={{ __html: svgMarkup }}
      />
    );
  }

  return (
    <Tag
      style={style}
      // className={`icon${className ? ` ${className}` : ""}`}
      onClick={onClick ? onClick : undefined}
    >
      <Iconify
        icon={icon}
        width={width}
        height={height}
        className={className ? className : ""}
      />
    </Tag>
  );
}
